import useWindowSize from 'hooks/use-windowSize';

import { useRouter } from 'next/router';

import Filters from '../filters/Filters';
import Sort from '../sort/Sort';

import classes from './Options.module.scss';

const Options = ({ sort, filters }) => {
	const { desktopDevice } = useWindowSize();
	const router = useRouter();

	const filtersCondition = () => {
		if (/category/.test(router.pathname)) {
			return desktopDevice && <Filters />;
		} else {
			return filters && <Filters />;
		}
	};

	return (
		<div className={`${!desktopDevice ? classes['sort-filter-btn'] : 'col-3 pt-4'}`}>
			{sort && <Sort />}
			{filters && filtersCondition()}
		</div>
	);
};

export default Options;
